import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { testHistorySortSelectStyles } from './styles';

export default function TestHistorySortSelect({ value, onChange }) {
  return (
    <FormControl size="small" sx={testHistorySortSelectStyles.formControl}>
      <InputLabel>Sort By</InputLabel>
      <Select value={value} onChange={(e) => onChange(e.target.value)} label="Sort By">
        <MenuItem value="newest">Newest First</MenuItem>
        <MenuItem value="oldest">Oldest First</MenuItem>
      </Select>
    </FormControl>
  );
}
